// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DragPreview15BindJs from "./DragPreview15.bind.js";

var make = DragPreview15BindJs.Preview;

export {
  make ,
  
}
/* make Not a pure module */
